const dict_management_zh = {
  edit_dict_type_info:'编辑字典类型信息',
  edit_dict_info:'编辑字典信息',
  dict_warning:'系统字典与代码中枚举关联，添加后不可修改',
  empty_type_name:'请输入类型名称',
  empty_type_code:'请输入类型编码',
  empty_dict_name:'请输入字典名称',
  empty_cict_code:'请输入字典编码',
  empty_super_dict:'请选择上级字典'
}

export default dict_management_zh



// WEBPACK FOOTER //
// ./src/common/lang/dict_management/dict_management_zh.js